import JSONLD from "src/utils/jsonld";
import { v4 as uuid } from "uuid";

import { IApiMutationFunction, createApiMutationHook } from "../../utils/api";
import { RelationalValue } from "../../utils/filters";
import { IClassroom } from "../types/IClassroom";

interface ClassroomCreateMutationData extends Pick<
    IClassroom,
    "title" | "description" | "startDate" | "endDate" | "externalReferences"
> {
    uuid?: string;
    frameworks: RelationalValue<IClassroom["frameworks"][number]>[];
    location?: RelationalValue<Required<IClassroom>["location"]>;
    factory: RelationalValue<IClassroom["factory"]>;
    language: RelationalValue<IClassroom["language"]>;
    image?: RelationalValue<NonNullable<IClassroom["image"]>>;
}

export type IClassroomCreateMutationParameters = {
    data: ClassroomCreateMutationData;
};

export type IClassroomCreateMutationResult = IClassroom;

export const classroomCreateMutation: IApiMutationFunction<IClassroomCreateMutationParameters> = ({ data }) => {
    return {
        method: "POST",
        url: `/classrooms`,
        data: {
            ...JSONLD.normalize(data),
            uuid: data.uuid ?? uuid(),
        },
    };
};

export const useClassroomCreateMutation = createApiMutationHook<
    IClassroomCreateMutationParameters,
    IClassroomCreateMutationResult
>(classroomCreateMutation);
